import React from "react";
import SalesReportList from "./salesReportList/SalesReportList";

const SalesReport = () => {
  return <SalesReportList />;
};

export default SalesReport;
